import { AbstractType } from 'src/lib/types/models/AbstractType'

// abstract class
export class SubmodelType extends AbstractType {}



// WEBPACK FOOTER //
// ./src/lib/types/models/SubmodelType.js